import { Table } from "semantic-ui-react";
import { CULTIVATION_LABEL_TYPE } from "../../../../config/constants";

export const cultivationData = (currnetData: any, fertilizerData: any, pesticideData: any) => {
  return (
    currnetData
      ?.map((cultivationData: any) => {
        const fertilizerList = cultivationData?.cultivationField?.fertilizerList || [];
        const pesticideList = cultivationData?.cultivationField?.pesticideList || [];
        const landUsageChange = cultivationData?.landUsageChange || "No";
        const yieldValue = cultivationData?.cultivationField?.yield || 0;
        const harvestYear = cultivationData?.cultivationField?.harvestYear;
        const growthArea = cultivationData?.cultivationField?.growthArea;
        const country = cultivationData?.originCountry;
        const produceType = cultivationData?.produceType;

        if (fertilizerList.length === 0) return null;

        const fertilizerListData = fertilizerList.map((item: any) => {
          const fertilizer = fertilizerData?.find((f: any) => parseInt(f.id) === parseInt(item.id));
          return {
            ...item,
            fertilizer_name: fertilizer?.fertilizer_name ?? "",
            id: parseInt(item.id),
            ownId: cultivationData._id
          };
        });

        const pesticideListData = pesticideList.map((item: any) => {
          const pesticide = pesticideData?.find((p: any) => parseInt(p.id) === parseInt(item.id));
          return { ...pesticide, ...item, id: parseInt(item.id), ownId: cultivationData._id };
        });

        return {
          processGateId: cultivationData._id,
          cultivationName: cultivationData?.farmGateName || "",
          fertilizerListData,
          pesticideListData,
          landUsageChange,
          fieldData: [{ yieldValue, harvestYear, growthArea }],
          country,
          produceType
        };
      })
      .filter(Boolean) || []
  );
};

export const getAllCultivationGroups = (data: any, produceTypes: any) => {
  const productTypeName =
    produceTypes?.find((pt: any) => parseInt(pt.key) === parseInt(data?.produceType))?.text || "";
  return [
    {
      label: CULTIVATION_LABEL_TYPE.GenericUser,
      items: data?.fieldData.map((item: any) => ({
        ...item,
        country: data?.country,
        produceType: productTypeName
      }))
    },
    { label: CULTIVATION_LABEL_TYPE.Fertilizer, items: data?.fertilizerListData },
    { label: CULTIVATION_LABEL_TYPE.Pesticide, items: data?.pesticideListData },
    {
      label: CULTIVATION_LABEL_TYPE.LandUseChange,
      items: [{ landUsageChange: data?.landUsageChange || "No" }]
    }
  ];
};

export const calculateTotalRows = (allCultivation: any[]) =>
  allCultivation.reduce((sum, group) => sum + (group.items.length || 1), 0);

export const renderEmptyRow = (
  dataIndex: number,
  groupIndex: number,
  currentRow: number,
  totalRows: number,
  packName: string,
  label: string
) => (
  <Table.Row key={`${dataIndex}-${groupIndex}-empty`}>
    {currentRow === 0 && <Table.Cell rowSpan={totalRows}>{packName}</Table.Cell>}
    <Table.Cell>{label}</Table.Cell>
    <Table.Cell colSpan="5" textAlign="center">
      No data available
    </Table.Cell>
  </Table.Row>
);

export const renderGroupSubHeader = (label: string) => {
  switch (label) {
    case "Fertilizer":
      return (
        <Table.Row className="group-sub-header">
          <Table.Cell />
          <Table.Cell>
            <strong>Fertilizer name</strong>
          </Table.Cell>
          <Table.Cell>
            <strong>kg/ha</strong>
          </Table.Cell>
          <Table.Cell />
          <Table.Cell />
          <Table.Cell />
        </Table.Row>
      );
    case "Pesticide":
      return (
        <Table.Row className="group-sub-header">
          <Table.Cell />
          <Table.Cell>
            <strong>Pesticide name</strong>
          </Table.Cell>
          <Table.Cell>
            <strong>kg/ha</strong>
          </Table.Cell>
          <Table.Cell />
          <Table.Cell />
          <Table.Cell />
        </Table.Row>
      );
    default:
      return null;
  }
};
